import toast from 'react-hot-toast';
import { DEFAULT_CONFIGS } from './onShowToast';
import BaseToastContainer from '@app/components/BaseToastContainer';

let toastId;
export default function onTokenNotFound(translate) {
  return function () {
    if (toastId) toast.remove(toastId);
    toastId = toast(t => {
      toastId = t.id;
      return <BaseToastContainer type="error" message={translate('AuthSessionNotFounded')} toastId={t.id} />;
    }, DEFAULT_CONFIGS);
  };
}
